import axiosInstance from './axiosConfig';

const API_URL = '/api/auth';

const register = (userData) => {
  return axiosInstance.post(`${API_URL}/register`, userData);
};

const login = (credentials) => {
  return axiosInstance.post(`${API_URL}/login`, credentials);
};

// Выход (отправляем запрос на сервер, чтобы он удалил refresh token)
const logout = () => {
  return axiosInstance.post(`${API_URL}/logout`);
};

const getProfile = () => {
  return axiosInstance.get(`${API_URL}/profile`);
};

// Запрос на новый accessToken с помощью refreshToken (в cookie)
const refreshToken = () => {
    return axiosInstance.get(`${API_URL}/refresh-token`);
};

const forgotPassword = (email) => {
    return axiosInstance.post(`${API_URL}/forgot-password`, { email });
};

const resetPassword = (token, password) => {
    return axiosInstance.patch(`${API_URL}/reset-password/${token}`, { password });
};


const authService = {
  register,
  login,
  logout,
  getProfile,
  refreshToken,
  forgotPassword,
  resetPassword,
};

export default authService;